<template>
  <div :class="containerClasses">
    <navigation :headings="tabHeadings" :active="activeTab"
      @click="changeActiveTab" :nav-classes="finalNavClasses">
    </navigation>
    <tab-content-wrapper :tabs="tabs" :active-tab="activeTab">
      <!-- Appropriate component or router-view
            will be inserted here -->
    </tab-content-wrapper>
  </div>
</template>

<script type="text/babel">
  import Navigation from './Navigation'
  import TabContentWrapper from './TabContentWrapper'
  import { resolveState, resolveMutation, resolveGetter } from 'store/modules/tabs/tabManagerFactory'

  export default {
    components: {
      Navigation,
      TabContentWrapper,
    },

    props: {
      navClasses: {
        type: Array,
        default () {
          return []
        },
      },

      containerClasses: {
        type: Array,
        default () {
          return []
        },
      },

      storeModule: {
        type: String,
        required: true
      },
    },

    data () {
      return {
        namespacedMutation: resolveMutation(this.storeModule),
        headingsGetter: resolveGetter(this.storeModule, 'tabHeadings'),
        moduleState: resolveState(this.storeModule, this.$store.state),
        finalNavClasses: [],
      }
    },

    created () {
      this.finalNavClasses = [
        ...this.navClasses,
        this.storeModule
      ]
    },

    mounted () {
      this.$root.$on('active-tab-updated', this.updateActiveTab)
    },

    beforeDestroy() {
      this.$root.$off('active-tab-updated', this.updateActiveTab)
    },

    methods: {
      isActiveTab (index) {
          return index === this.activeTab
      },

      changeActiveTab (tabId) {
        this.$store.commit(this.namespacedMutation, tabId)
      },

      updateActiveTab (event) {
        if (event.storeModule == this.storeModule) {
          const tabId = Number.isInteger(event.target) ? event.target : this.tabs.map(t => t.name).indexOf(event.target)

          if (-1 != tabId) {
            this.changeActiveTab(tabId)
          }
        }
      }
    },

    computed: {

      tabs () {
        // debugger
        if (this.moduleState.available_tabs_indexes == null) {
          return this.moduleState.tabsArray
        } else {
          return _.filter(this.moduleState.tabsArray, tab =>
            _.find(this.moduleState.available_tabs_indexes, idx => _.indexOf(this.moduleState.tabsArray, tab) === idx) != undefined
          )
        }
      },

      activeTab () {
        return this.moduleState.activeTab
      },

      tabHeadings () {
        return this.$store.getters[this.headingsGetter]
      }
    }
  }
</script>



// WEBPACK FOOTER //
// client/components/Tabs/Tabs.vue